// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2r2uc","questions":"styles_questions__WWKUx","footer":"styles_footer__3zYmS"};